import { render, staticRenderFns } from "./ObjectListPriceListComponent.vue?vue&type=template&id=657ecf5e&"
import script from "./ObjectListPriceListComponent.vue?vue&type=script&lang=js&"
export * from "./ObjectListPriceListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports